export const USER_OPTIONS = {
  Cargos: [
    { value: 0, text: '-- Seleccione un cargo -- ' },
    { value: 1, text: 'Dueño' },
    { value: 2, text: 'Operario' },
  ],
};

export const ITEM_OPTIONS = {
  RadiosDeAccion: [
    { value: 0, text: '-- Alcance de su servicio -- ' },
    { value: 1, text: '100 km' },
    { value: 2, text: '200 km' },
    { value: 3, text: '500 km' },
    { value: 4, text: '1000 km' },
    { value: 5, text: '2000 km' },
    { value: 6, text: 'Más de 2000 km' },
  ],
  TiposDeEnvios: [
    { value: 0, text: '-- Seleccione una opción -- ' },
    { value: 1, text: 'Sin envíos' },
    { value: 2, text: 'Envíos locales' },
    { value: 3, text: 'Envíos provinciales' },
    { value: 4, text: 'Envíos nacionales' },
  ],
  Unidades: {
    Productos: [
      { value: 0, text: '-- und. -- ' },
      { value: 1, text: 'Kilos' },
      { value: 2, text: 'Bolsas' },
      { value: 3, text: 'Litros' },
    ]
  },
  Monedas: [
    { value: 0, text: '--- ' },
    { value: 1, text: 'Peso Argentino' },
    { value: 2, text: 'U$D' },
  ],
  Categorias: {
    Productos: [
      { "value": 0, "text": "-- Seleccione una Categoría -- " },
      { "value": 1, "text": "Agroquímicos" },
      { "value": 4, "text": "Fertilizantes" },
      { "value": 5, "text": "Otros productos" },
      { "value": 3, "text": "Repuestos" },
      { "value": 2, "text": "Semillas" },
      { "value": 99, "text": "Otro" }
    ],
    Maquinaria: [
      { "value": 0, "text": "-- Seleccione una Categoría -- " },
      { "value": 4, "text": "Camiones" },
      { "value": 10, "text": "Cosechadoras" },
      { "value": 1, "text": "Desmalezadoras" },
      { "value": 2, "text": "Fertilizadoras" },
      { "value": 3, "text": "Mixers" },
      { "value": 5, "text": "Palas cargadoras" },
      { "value": 6, "text": "Pulverizadoras" },
      { "value": 7, "text": "Sembradoras" },
      { "value": 8, "text": "Tolvas" },
      { "value": 9, "text": "Tractores" },
      { "value": 99, "text": "Otra" }
    ],
    Inmuebles: [
      { "value": 0, "text": "-- Seleccione una Categoría -- " },
      { "value": 1, "text": "Campos" },
      { "value": 2, "text": "Casas" },
      { "value": 4, "text": "Departamento" },
      { "value": 3, "text": "Fincas" },
      { "value": 6, "text": "Galpón" },
      { "value": 7, "text": "Granja" },
      { "value": 5, "text": "Silo" },
      { "value": 99, "text": "Otro" }
    ],
    Servicios: [
      { "value": 0, "text": "-- Seleccione una Categoría -- " },
      { "value": 18, "text": "Agricultura de presición" },
      { "value": 1, "text": "Arado" },
      { "value": 13, "text": "Consultoría Agrícola" },
      { "value": 14, "text": "Consultoría Veterinaria" },
      { "value": 15, "text": "Contabilidad" },
      { "value": 2, "text": "Cosecha" },
      { "value": 3, "text": "Embolsado de granos" },
      { "value": 4, "text": "Extracción de granos" },
      { "value": 6, "text": "Fertilización" },
      { "value": 7, "text": "Labranza vertical" },
      { "value": 16, "text": "Logística" },
      { "value": 8, "text": "Pulverización" },
      { "value": 9, "text": "Rastra" },
      { "value": 10, "text": "Siembra" },
      { "value": 12, "text": "Transporte de granos" },
      { "value": 11, "text": "Ventas" },
      { "value": 17, "text": "Vuelo de drones" },
      { "value": 99, "text": "Otro" }
    ]
  }
};
